import React, { Component } from 'react'
import { Link } from 'react-router'
import mousetrap from 'mousetrap'

import classNames from './Menu.css'

export default class Menu extends Component {
  componentDidMount () {
    mousetrap.bind('escape', this.props.closeMenu)
  }
  componentWillReceiveProps (nextProps) {
    if (!this.props.open && nextProps.open) {
      document.body.style.overflow = 'hidden'
    }
    if (this.props.open && !nextProps.open) {
      document.body.style.overflow = ''
    }
  }
  componentWillUnmount () {
    document.body.style.overflow = ''
    mousetrap.unbind('escape')
  }
  render () {
    const { open, items, closeMenu } = this.props
    return (
      <ul className={open ? classNames.open : classNames.closed} onClick={closeMenu}>
        {items.map(renderItem)}
      </ul>
    )
  }
}

function renderItem ({ text, onClick, href, shouldShow, ...props }) {
  if (typeof shouldShow !== 'undefined' && !shouldShow) {
    return null
  }
  if (href) {
    return (
      <li key={text} className={classNames.item}>
        <Link to={href} className={classNames.link} {...props}>
          {text}
        </Link>
      </li>
    )
  }
  return (
    <li key={text} className={classNames.item}>
      <button onClick={onClick} className={classNames.link} {...props}>
        {text}
      </button>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu.js